import { Conditional } from '@resurs/react-utils'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Column, Columns } from '@resurs/midas-react'
import { ApplicationStatus } from '../../../../models/application-status'
import { validateAddress } from '../../../../store/actions/faroe-islands-actions'
import FlowModalUI from '../shared/FlowModalUI'
import PaymentMethodForm from './PaymentMethodForm'
import {
  getCoApplicantInfoAsync,
  prepareForRedirection,
  redirectionCompleted,
} from '../../../../store/actions/pay-apply-actions'
import { CustomerTypeModel } from '../../models/private-models'

class ApplicationFormPage extends Component {
  static getDerivedStateFromProps(props, state) {
    if (
      [
        ApplicationStatus.ESKAT_REQUIRED,
        ApplicationStatus.PSP_REDIRECTION_REQUIRED,
        !props.data.pushedOutToCustomer &&
          ApplicationStatus.CUSTOMER_INTERACTION_REQUIRED,
      ].includes(props.data.current.status) &&
      props.data.current.id !== state.abort
    ) {
      if (!state.flowModal) {
        props.prepareRedirection()
      }
      return {
        flowModal: true,
      }
    }
    return {
      flowModal: false,
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      flowModal: false,
    }
  }

  onNext(appData) {
    const applicationData = JSON.parse(JSON.stringify(appData))
    this.props.onNext(applicationData)
  }

  abortFlow() {
    this.setState({
      flowModal: false,
      // eslint does not recognize field since it is used from a static context only
      // eslint-disable-next-line react/no-unused-state
      abort: this.props.data.current.id,
    })
  }

  render() {
    return (
      <Columns>
        <Column col1 colMd0 />
        <Column col10 colMd12>
          <PaymentMethodForm
            formData={this.props.data.formSpec.formSchema}
            onNext={appData => this.onNext(appData)}
            newPageLoading={this.props.data.wizard.newPageLoading}
            onPageLoading={this.props.data.wizard.onPageLoading}
            onPrevious={this.props.onPrevious}
            getCoappInfo={id => this.props.getCoApplicantInfo(id)}
            validateAddress={this.props.validateAddress}
            countryCode={this.props.data?.addressInfo?.countryCode}
            hasPushOut={
              !!this.props.data.current.selectedLimit &&
              this.props.data.addressInfo.customerType !==
                CustomerTypeModel.LEGAL
            }
            selectedPaymentMethod={
              this.props.data.current.selectedPaymentMethod.type
            }
            redirectionResult={this.props.data?.redirectionResult}
            isPushedOut={this.props.data.pushedOutToCustomer}
          />
          <Conditional when={!!this.state.flowModal}>
            <FlowModalUI
              show
              data={this.props.data}
              onComplete={() => {
                this.props.redirectionCompleted()
              }}
              onClose={() => {
                this.abortFlow()
              }}
            />
          </Conditional>
        </Column>
      </Columns>
    )
  }
}

ApplicationFormPage.propTypes = {
  data: PropTypes.object.isRequired,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  redirectionCompleted: PropTypes.func.isRequired,
  getCoApplicantInfo: PropTypes.func.isRequired,
  validateAddress: PropTypes.func.isRequired,
  prepareRedirection: PropTypes.func.isRequired,
}

ApplicationFormPage.defaultProps = {
  onNext: null,
  onPrevious: null,
}

const mapDispatchToProps = dispatch => ({
  getCoApplicantInfo: id => dispatch(getCoApplicantInfoAsync(id)),
  prepareRedirection: () => dispatch(prepareForRedirection()),
  redirectionCompleted: () => dispatch(redirectionCompleted()),
  validateAddress: (street, postalCode) =>
    dispatch(validateAddress(street, postalCode)),
})

export default connect(null, mapDispatchToProps)(ApplicationFormPage)
